import loginTypes from '../login/loginTypes'
import types from './rpdTypes'

let initialState = {
    specialtyCodesList: [], // Направления подготовки
    disciplinesList: [], // Дисциплины
    filesList: [], // Файлы
}

const rpdReducer = (state = initialState, action: any) => {
    switch (action.type) {

        // Выход из системы
        case loginTypes.LOGIN_SET_LOGOUT: {
            return {
                ...state = initialState
            }
        }

        // Загрузка направлений подготовки
        case types.RPD_SET_SPECIALTY_CODES: {
            return {
                ...state,
                specialtyCodesList: action.items
            }
        }

        // Загрузка дисциплин
        case types.RPD_SET_DISCIPLINES: {
            return {
                ...state,
                disciplinesList: action.items
            }
        }

        // Загрузка списка файлов
        case types.RPD_SET_FILES: {
            return {
                ...state,
                filesList: action.items
            }
        }

        default: return state
    }
}

export default rpdReducer